import { defaultTheme } from '@3plearning/react-components';

export default {
  ...defaultTheme.overrides,
  dropdownMenu: {
    menu: {
      optionPadding: '10px 8px'
    }
  },

  header: {
    colours: {
      main: {
        background: '#dbe3e9'
      },
      subtitle: {
        text: '#4e5c67'
      },
      subheader: {
        background: '#dbe3e9'
      }
    },
    spacing: 10,
    subtitle: {
      borderRadius: '0px',
      borderWidth: '0px',
      padding: '6px'
    }
  },

  button: {
    borderRadius: '0px'
  },

  modal: {
    maxWidth: '800px',
    width: '800px'
  },

  calendar: {
    colours: {
      day: {
        selected: {
          background: '#7ca2bb',
          text: '#fff'
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./themes/course-assign-theme/overrides.js